export const getColumnClassNames = (size) => (
    (typeof size !== 'object') ? `col-${size}` : size
        .map((item) => `col-${item}`)
        .reduce((acc, val) => acc.concat(val), [])
        .filter((item) => item).join(' ')
);
